"use client";
import React from "react";
import Image from "next/image";
import { usePathname } from "next/navigation";
import { useState } from "react";

export function SocialShare() {
  const [copySuccessful, setCopySuccessful] = useState(false);
  const pathname = usePathname();
  const URL = process.env.API_URL;
  const socialMediaIcons = [
    {
      name: "/icons/facebook-button.svg",
      width: 50,
      height: 42,
      link: "https://www.facebook.com/sharer/sharer.php?u=" + URL + pathname,
      color: "#1876F2",
      textColor: "text-white",
    },
    {
      name: "/icons/twitter-button.svg",
      width: 50,
      height: 42,
      link: "https://twitter.com/intent/tweet?url=" + URL + pathname,
      color: "#1DA1F2",
      textColor: "text-white",
    },
    {
      name: "/icons/linkedin-button.svg",
      width: 50,
      height: 42,
      link: "https://www.linkedin.com/shareArticle?url=" + URL + pathname,
      color: "#0A66C2",
      textColor: "text-white",
    },
    {
      name: "/icons/whatsapp-button.svg",
      width: 50,
      height: 42,
      link: "https://api.whatsapp.com/send?text=" + URL + pathname,
      color: "#25D366",
      textColor: "text-white",
    },
    {
      name: "/icons/telegram-button.svg",
      width: 50,
      height: 42,
      link: "https://t.me/share/url?url=" + URL + pathname,
      color: "#25A3E1",
      textColor: "text-white",
    },
    {
      name: "/icons/link-icon.svg",
      width: 18,
      height: 18,
      link: "pathname",
      title: "Bağlantını koyala",
      color: "white",
      textColor: "text-[#94A3B8]",
    },
  ];
  const shareBlog = (link) => {
    const windowWidth = 800;
    const windowHeight = 600;
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;

    const left = (screenWidth - windowWidth) / 2;
    const top = (screenHeight - windowHeight) / 2;

    const windowFeatures = `width=${windowWidth},height=${windowHeight},top=${top},left=${left}`;

    if (link == "pathname") {
      copyToClipboard(URL + pathname);
    } else {
      window.open(link, "_blank", windowFeatures);
    }
  };
  const copyToClipboard = async (textToCopy) => {
    try {
      await navigator.clipboard.writeText(textToCopy);
      setCopySuccessful(true);
    } catch (err) {
      console.log("Error");
    }
  };

  return (
    <div className="social-media-icons">
      <ul className="flex flex-col gap-4"></ul>
      {socialMediaIcons?.map(({ name, width, height, link }, index) => (
        <React.Fragment key={index}>
          <div
            onClick={() => shareBlog(link)}
            className="w-[50px] h-[42px] my-3 border-slate-200 flex justify-center items-center cursor-pointer border-[0.5px] rounded-[21px]"
          >
            <Image
              src={
                name === "/icons/link-icon.svg" && copySuccessful
                  ? "/icons/copy.svg"
                  : name
              }
              alt={name}
              width={width}
              height={height}
            />
          </div>
        </React.Fragment>
      ))}
    </div>
  );
}
